import { ReactNode, useId } from "react";
import styles from "./Form.module.css";
import { cx } from "../utils";

export interface FormFieldProps {
    label?: ReactNode;
    hint?: ReactNode;
    error?: string | ReactNode;
    required?: boolean;
    htmlFor?: string;
    children: ReactNode;
    className?: string;
}

export const FormField = ({ label, hint, error, required = false, htmlFor, children, className }: FormFieldProps) => {
    const generatedId = useId();
    const hintId = hint ? `${generatedId}-hint` : undefined;
    const errorId = error ? `${generatedId}-error` : undefined;
    const controlId = htmlFor ?? generatedId;

    return (
        <div className={cx(styles.field, className)}>
            {label ? (
                <div className={styles.labelRow}>
                    <label htmlFor={controlId} className={styles.label}>
                        {label}
                    </label>
                    {required ? <span className={styles.required}>*</span> : null}
                </div>
            ) : null}
            <div className={styles.control} data-state={error ? "error" : "default"}>
                {children}
            </div>
            {hint ? (
                <div id={hintId} className={styles.hint}>
                    {hint}
                </div>
            ) : null}
            {error ? (
                <div id={errorId} className={styles.error}>
                    {error}
                </div>
            ) : null}
        </div>
    );
};
